import { useQuery } from "@apollo/client";
import version from "enefel/version";
import { FC } from "react";
import styled from "styled-components";
import { GET_ME, GET_SERVER_TEST } from "../../query/UserQueries";
import Copyright from "./Copyright";
import Discord from "./Discord";
import Facebook from "./Facebook";
import { Instagram } from "./Instagram";
import { TikTok } from "./TikTok";
import { YouTube } from "./YouTube";

const FooterWrapper = styled.div`
  align-items: center;
  color: white;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-wrap: wrap;

  a {
    color: white;
    margin: 0 0.5em;
  }

  img {
    width: 20px;
    height: 20px;
  }

  & > *:first-child {
    margin-right: 1em;
  }
`;

const NoWrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  margin-top: 0.5rem;
`;

const VersionText = styled.div`
  color: rgba(255, 255, 255, 0.3);
  font-size: 0.7rem;
  margin-left: 1em;
`;

const ServerTestText = styled.div`
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.6rem;
  margin-left: 0.5em;
  font-style: italic;
`;

type SmallFooterProps = {};

export const SmallFooter: FC<SmallFooterProps> = () => {
  const { data: meData } = useQuery(GET_ME);
  const { data: serverTestData } = useQuery(GET_SERVER_TEST, {
    skip: !meData?.me?.isAdmin,
  });

  const isAdmin = meData?.me?.isAdmin;
  const serverVersion = serverTestData?.serverTest;

  return (
    <FooterWrapper>
      <Copyright />
      <NoWrap>
        <Facebook />
        <TikTok />
        <YouTube />
        <Instagram />
        <Discord />
        <VersionText>v{version}</VersionText>
        {isAdmin && serverVersion && (
          <ServerTestText>server: {serverVersion}</ServerTestText>
        )}
      </NoWrap>
    </FooterWrapper>
  );
};
